import { MinusCircleIcon, DocumentDuplicateIcon, CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@heroui/react";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay, UpdateBookingCommanWay, UpdateCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Input } from "components";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import { InputTable } from "components/DataTable/InputTable";
import { TrainTrackingModal } from "components/TrainTrackingModal";
import { useFormik } from "formik";
import { debounce } from "lodash";
import moment from "moment";
import { any } from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import handleWheel from "utils/handleOnWheel";
import { get_file_url } from "utils/lib-utils";
import { AfDataType as ADT } from "utils/TableColumnData";
import { AwbLabel } from "components/PrintLabels/AwbLabel";
import { number, object, string } from "yup";

type OptionType = {
  value: number;
  label: string;
};

interface MotherBagState {
  mode?: string;
  data?: { [key: string]: any }; // Adjust the type based on your data structure
  // Add other properties if needed
}

interface ValuesType {
  destination?: { value: string; label: string };
}

const MotherBagInScan: React.FC = ({}) => {
  let isDisabled = false;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { mode = "add", data = {} } = (state || {}) as MotherBagState; // Check for existence and type assertion

  const [motherBagList, setMotherBagList] = useState<any>([]);
  const [motherbagGroupWiseList, setMotherbagGroupWiseList] = useState<any>({});
  const [selectedMotherbag, setSelectedMotherbag] = useState<any>(null);

  const [selectedViewMore, setSelectedViewMore] = useState<any>(null);

  const [awbDataList, setAwbDataList] = useState<any>([]);

  const [acceptedAwbNos, setAcceptedAwbNos] = useState<any>([]);

  const awbSectionRef = useRef<HTMLDivElement>(null);
  const mbagScanRef = useRef<HTMLInputElement>(null);
  const awbScanRef = useRef<HTMLInputElement>(null);

  const [filterStartDt, setFilterStartDt] = useState<any>(moment().subtract(1, "day").startOf("day"));
  const [filterEndDt, setFilterEndDt] = useState<any>(moment().endOf("day"));

  const [motherbagStatusList, setMotherbagStatusList] = useState<any[]>([]);
  const [selectedMotherbagStatus, setSelectedMotherbagStatus] = useState<any>({});
  const [statusFilter, setStatusFilter] = useState<any>({ value: "", label: "All" });

  // Action menu and status modal state
  const [openActionMenu, setOpenActionMenu] = useState<number | null>(null);
  const [statusUpdateModal, setStatusUpdateModal] = useState<any | null>(null);

  // Train tracking modal state
  const [trainTrackingModal, setTrainTrackingModal] = useState<{ isOpen: boolean; trainNo: string; defaultDate?: string }>({ isOpen: false, trainNo: "" });

  // AWB Label modal state
  const [isLabelOpen, setIsLabelOpen] = useState(false);
  const [labelAwbData, setLabelAwbData] = useState<any>({});

  // Refs to latest data so debounced callbacks always see current values
  const motherBagListRef = useRef<any[]>([]);
  motherBagListRef.current = motherBagList;
  const awbDataListRef = useRef<any[]>([]);
  awbDataListRef.current = awbDataList;
  const acceptedAwbNosRef = useRef<any[]>([]);
  acceptedAwbNosRef.current = acceptedAwbNos;

  // Debounced motherbag scan handler (stable ref, no re-creation)
  const trySelectMotherbag = useRef(
    debounce((val: string, resetFormFn: any, awbSectionEl: React.RefObject<HTMLDivElement>, inputEl: React.RefObject<HTMLInputElement>) => {
      if (!val) return;
      const found = motherBagListRef.current.find((m: any) => m.mother_bag_code === val);
      if (found) {
        const isSelectable = (found.outscanDone && !found.inscanDone) || found.status === "SHORT";
        if (isSelectable) {
          setSelectedMotherbag(found.id);
          resetFormFn();
          setTimeout(() => {
            awbSectionEl.current?.scrollIntoView({ behavior: "smooth", block: "start" });
            awbScanRef.current?.focus();
          }, 200);
        }
        if (inputEl.current) inputEl.current.value = "";
      }
    }, 150)
  ).current;

  // Debounced AWB scan handler (stable ref, no re-creation)
  const tryMatchAwb = useRef(
    debounce((val: string, inputEl: React.RefObject<HTMLInputElement>) => {
      if (!val) return;
      const found = awbDataListRef.current.some((a: any) => a.awb_no === val);
      if (found && !acceptedAwbNosRef.current.includes(val)) {
        setAcceptedAwbNos((prev: any[]) => [...prev, val]);
        if (inputEl.current) inputEl.current.value = "";
      }
    }, 100)
  ).current;

  const [mySubbranch, setMySubbranch] = useState<any>(false);
  React.useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      setMySubbranch(userD.state.user.subbranch);
    }
  }, []);

  React.useEffect(() => {
    console.log("mySubbranch", mySubbranch);
    if (mySubbranch) {
      setTimeout(refetchData, 200);
    }
  }, [mySubbranch]);

  const { refetch: mbag_status } = useQuery(["MbagStatusList"], () => GetCommanWay("/admin/mbag_status_list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        console.log(data.data);
        setMotherbagStatusList(data.data);
      }
    },
  });

  useEffect(() => {
    if (selectedMotherbag) {
      console.log(selectedMotherbag);
      setTimeout((x) => {
        awbDataRefetch();
      }, 100);
    }
  }, [selectedMotherbag]);
  const { refetch: awbDataRefetch } = useQuery(
    ["AWBList"],
    () =>
      ListCommanWay(
        "/admin/awbdata/list",
        { mother_bag_id: selectedMotherbag, isInscan: true },
        {
          include: [],
          paginate: 1000,
        }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        console.log(data);
        if (data.status == "SUCCESS") {
          let mbagData: any = {};
          motherBagList.forEach((m) => {
            if (m.id == selectedMotherbag) {
              mbagData = m;
            }
          });
          let shortAwbs = mbagData.shortAwbs ? mbagData.shortAwbs.split(",") : [];

          let finalAwbs = data.data.data;
          if (shortAwbs.length) {
            finalAwbs = [];
            data.data.data.forEach((a) => {
              if (shortAwbs.includes(a.awb_no)) {
                finalAwbs.push(a);
              }
            });
          }
          setAwbDataList(finalAwbs);
        }
      },
    }
  );
  const { refetch: refetchData } = useQuery(
    ["MotherBagInApi"],
    () =>
      ListCommanWay(
        "/admin/mother_bag/list",
        {
          outscanDone: true,
          isInscan: true,
          delivery_subbranch: mySubbranch,
          $and: {
            $or: {
              $and: {
                createdAt: {
                  $gte: filterStartDt,
                  $lte: filterEndDt,
                },
              },
            },
          },
        },
        { paginate: 10000, include: ["_destination", "_subbranch", "_vendor", "_flight", "_airline"] }
      ),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          

          const sortedData = [...data.data.data].sort((a, b) => {
            const branchA = a._subbranch?.branch_name || '';
            const branchB = b._subbranch?.branch_name || '';
            return branchA.localeCompare(branchB);
          });

          setMotherBagList(sortedData);

          // Group by date then by origin
          const newData = sortedData.reduce((dateGroups, m) => {
            const date = moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD/MM/YYYY");
            const origin = m._subbranch?.branch_name || "Unknown";

            if (!dateGroups[date]) {
              dateGroups[date] = {};
            }
            if (!dateGroups[date][origin]) {
              dateGroups[date][origin] = [];
            }
            dateGroups[date][origin].push(m);
            return dateGroups;
          }, {});

          setMotherbagGroupWiseList(newData);

        }
      },
    }
  );

  const { mutate: addMotherbag_pod } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag Status Changed", "success");
        resetForm();
        setAwbDataList([]);
        setSelectedMotherbag(null);
        refetchData();

      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });

  const { mutate: ReleaseAwbNosMutate } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Airwaybill release successfully", "success");
        proceedToInScan();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Cannot Release Airwaybill Numbers. Try Again OR Contact Admin!", "error");
    },
  });
  const { mutate: InScanMotherbag } = useMutation(UpdateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag in-scan complete", "success");
        resetForm();
        setAwbDataList([]);
        setAcceptedAwbNos([]);
        setSelectedMotherbag(null);
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag in-scan. Try Again OR Contact Admin!", "error");
    },
  });

  const proceedToInScan = () => {
    InScanMotherbag({
      url: "/admin/mother_bag/update/" + selectedMotherbag,
      data: {
        inScanPOD: true,
        inscanDone: true,
        selectedAwbs: acceptedAwbNos,
        status: "RECEIVED",
      },
    });
  };

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, setErrors, touched, dirty, resetForm, setFieldValue } =
    useFormik({
      validationSchema: object().shape({}),
      initialValues: {
        subbranch: { value: 0, label: "" },
      },
      onSubmit: async (values, { resetForm }) => {
        console.log("values", values);
        console.log("selcted mbag", selectedMotherbag);
        console.log("accpeted", acceptedAwbNos);
        if (!selectedMotherbag) {
          UseToast("Select Motherbag", "error");
          return;
        }
        if (acceptedAwbNos.length == 0) {
          UseToast("Scan atleast 1 Airwaybill", "error");
          return;
        }

        let awbToRelease: any[] = [];
        awbDataList.forEach((a) => {
          if (!acceptedAwbNos.includes(a.awb_no)) {
            awbToRelease.push(a.awb_no);
          }
        });

        if (awbToRelease.length > 0) {
          //alert("Cannnot Inscan! missing " + awbToRelease.length + " Airwaybill");
          //return;
          Swal.fire({
            title: "Are you Sure!",
            text: "you want to Declare as Short Piece: " + awbToRelease.join(", "),
            icon: "question",
            confirmButtonText: "Yes",
            showCancelButton: true,
          })
            .then((x) => {
              if (x.isConfirmed) {
                InScanMotherbag({
                  url: "/admin/mother_bag/update/" + selectedMotherbag,
                  data: {
                    shortAwbs: awbToRelease,
                    selectedAwbs: acceptedAwbNos,
                    inScanPOD: true,
                    inscanDone: true,
                    status: "RECEIVED",
                  },
                });
              } else {
                ////proceedToInScan();
              }
            })
            .catch((c) => {
              ////proceedToInScan();
            });
        } else {
          proceedToInScan();
        }
        //mutateUpdateMotherBag(data.id);
        //navigate("/mother_bag/list");
        return;
      },
    });

  const disableEnterKey = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault();
    }
  };

  const doShowRow = (m: any) => {
    switch (statusFilter.value) {
      case "":
        return true;
        break;
      case "pending":
        return m.outscanDone && !m.inscanDone ? true : false;
        break;
      case "received":
        return m.inscanDone ? true : false;
        break;
    }
  };

  const getModeSvg = (mode) => {
    switch (mode) {
      case "By Train":
        return (
          <svg className="bg-white p-1 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 24 24">
            \{" "}
            <path
              fill="#B8001F"
              d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
        );
      case "By Road":
        return (
          <svg className="bg-gray-400 p-2 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <path d="m0 0h48v48h-48z" fill="#fff" fillOpacity=".01" />
              <g stroke="#000" strokeWidth="4" transform="translate(6 5.091863)">
                <path d="m5 .90813664-5 35.99999996" />
                <path d="m36.9287415.90813664-4.9643707 35.95523776" transform="matrix(-1 0 0 1 67.928742 0)" />
                <path d="m18 .90813664v6" />
                <path d="m18 29.9081366v7" />
                <path d="m18 14.9081366v7" />
              </g>
            </g>
          </svg>
        );
      case "By Air":
        return (
          <div className="bg-black-900 p-2 rounded-full w-9 h-9">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512">
              <path
                fill="#08C2FF"
                d="m490.7 0c-21.3 0-42.7 0-53.3 10.7l-85.3 96h-330.8l-21.3 32 234.7 74.7-64 85.3h-96l-32 32 64 21.3v32c.7 11.5 10.7 21.3 21.3 21.3h32l21.3 64 32-32v-96l85.3-64 74.7 234.7 32-21.3v-330.7l96-85.3c10.7-10.7 10.7-32 10.7-53.4 0-10.6-10.7-21.3-21.3-21.3z"
              />
            </svg>
          </div>
        );
      default:
        return mode;
    }
  };

  return (
    <>
      <div className="flex items-center justify-between font-inter mt-2 mb-4 mx-4">
        <h1 className="text-2xl font-black px-2 py-1 underline">Mother Bag IN-SCAN</h1>
        <div className="flex items-center gap-3">
          <input
            type="text"
            ref={mbagScanRef}
            className="w-56 px-3 py-1.5 rounded-lg border-2 border-orange-300 bg-orange-50 focus:border-orange-500 focus:ring-2 focus:ring-orange-200 outline-none text-sm font-medium transition-all"
            placeholder="Scan motherbag code..."
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Tab") {
                e.preventDefault();
              }
            }}
            onInput={(e: any) => {
              trySelectMotherbag(e.target.value, resetForm, awbSectionRef, mbagScanRef);
            }}
          />
        </div>
        <div className="flex items-center justify-center gap-3">
          <AfDateRangePicker
            startDate={filterStartDt.format("YYYY-MM-DD")}
            endDate={filterEndDt.format("YYYY-MM-DD")}
            setStartDate={(e: any) => {
              setFilterStartDt(moment(e).startOf("day"));
            }}
            setEndDate={(e: any) => {
              setFilterEndDt(moment(e).endOf("day"));
            }}
            label="Date Range"
            page="motherbag"
          />
          <Button
            type="button"
            className="rounded-md px-2 py-2.5 text-sm font-medium text-white bg-blue-500 border hover:bg-opacity-60 focus:z-10"
            onClick={refetchData}
          >
            Search
          </Button>

          <div className="w-36 ml-10">
            <Select
              className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
              options={[
                { value: "", label: "All" },
                { value: "pending", label: "Pending" },
                { value: "received", label: "Received" },
              ]}
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e);
              }}
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
      >
        {/* <div className="grid grid-cols-2 sm:grid-cols-1 gap-4 px-4"> */}
        <div className="px-2 font-inter">
          {Object.entries(motherbagGroupWiseList).map(([date, origins]: any, i) => (
            <div key={date} className="mb-6 pt-2 pb-[1px] rounded-lg bg-[#DEDED1]">
              <div className="flex-1">
                <div className="mb-2 px-2">
                  <h4 className="text-lg font-bold">Date: {date}</h4>
                  <Table className="p-1 rounded-md" isCompact removeWrapper>
                    <TableHeader className="text-center bg-black-900 text-white">
                      <TableColumn className="bg-black-900 text-white py-2 px-2">Action</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">ID.</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Date</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Motherbag No</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Origin</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Destination</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Mode</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Total<br/>Nos.</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Remark</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Tag Id</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Status</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Slip</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">Last Remark</TableColumn>
                      <TableColumn className="bg-black-900 text-white px-1 text-center">...</TableColumn>
                    </TableHeader>
                    <TableBody>
                      {Object.entries(origins).map(([origin, bags]: any, i2) => (
                        <>
                          {!statusFilter.value && (
                            <TableRow key={i + "blank-" + i2} className="bg-[#DEDED1]">
                              <TableCell className="text-xs p-0" colSpan={14}>&nbsp;</TableCell>
                            </TableRow>
                          )}

                          {bags.map(
                            (m) =>
                              doShowRow(m) && (
                                <>
                                  <TableRow
                                    key={i + "-" + m.id}
                                    className={`border-t border-black-900_0c ${
                                      m.status == "SHORT"
                                        ? "bg-teal-600 text-white"
                                        : m.inscanDone
                                        ? "bg-green-500"
                                        : m.id == selectedMotherbag
                                        ? "bg-blue-200"
                                        : "bg-red-400"
                                    }`}
                                  >
                                    <TableCell className="rounded-l-md">
                                      <Button
                                        type="button"
                                        className="text-xs bg-primary text-white px-1 py-0.5 mr-2"
                                        onClick={() => {
                                          setSelectedViewMore(m.id);
                                        }}
                                      >
                                        View
                                      </Button>
                                      {m.inscanDone && m.status != "SHORT" ? (
                                        <></>
                                      ) : m.id == selectedMotherbag ? (
                                        <span className="text-sm px-1 font-semibold">Selected</span>
                                      ) : (
                                        <Button
                                          type="button"
                                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10"
                                          onClick={() => {
                                            setSelectedMotherbag(m.id);
                                            resetForm();
                                          }}
                                        >
                                          Select
                                        </Button>
                                      )}
                                    </TableCell>
                                    <TableCell className="text-center">{m.id}</TableCell>
                                    <TableCell>
                                      <div className="leading-none">
                                        <span className="whitespace-nowrap font-semibold">
                                          {moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD/MM/YYYY")}
                                        </span>
                                        <br />
                                        <span className="whitespace-nowrap text-xs font-semibold">
                                          {moment(m.createdAt, "DD-MM-YYYY HH:mm").format("HH:mm")}
                                        </span>
                                      </div>
                                    </TableCell>
                                    <TableCell className="px-2 whitespace-nowrap text-center">
                                      <span
                                        className="cursor-pointer hover:underline font-semibold font-opensans"
                                        onClick={() => {
                                          navigate("/mother_bag/add", {
                                            state: {
                                              mode: "view",
                                              data: m,
                                            },
                                          });
                                        }}
                                      >
                                        {m.mother_bag_code}
                                      </span>
                                    </TableCell>
                                    <TableCell className="text-center">{m._subbranch?.branch_name}</TableCell>
                                    <TableCell className="text-center">{m._destination?.city_name}</TableCell>
                                    <TableCell className="py-0 text-center">{getModeSvg(m.modeOfPkg)}</TableCell>
                                    <TableCell className="text-center">{m.totalNos}</TableCell>
                                    <TableCell className="font-RobotoCondensed text-sm">{m.remark}</TableCell>
                                    <TableCell className="font-RobotoCondensed text-sm">{m.refNo}</TableCell>
                                    <TableCell className="text-center">{m.status}</TableCell>
                                    <TableCell className="text-center">
                                      {m?.VendorSlips?.length ? (
                                        <a
                                          href={(m?.VendorSlips?.length && get_file_url(m?.VendorSlips[m?.VendorSlips?.length - 1].slip_url)) || ""}
                                          target="_blank"
                                          className={`inline-block rounded-md px-2 py-1 text-sm font-medium bg-black-900 border border-gray-200 focus:z-10 mr-1 ${
                                            !m?.VendorSlips?.length ? "bg-gray-400 text-gray-600" : "text-white hover:bg-opacity-60"
                                          }`}
                                        >
                                          Slip
                                        </a>
                                      ) : (
                                        "-"
                                      )}
                                    </TableCell>
                                    <TableCell>{m.motherbad_pods && m.motherbad_pods.length > 0 && m.motherbad_pods[0].remark}</TableCell>
                                    <TableCell className="p-1 rounded-r-md">
                                      <div className="relative inline-block">
                                        {/* Live Train Tracking Button */}
                                        {m.mawbStatus?.train_no && (
                                          <button
                                            type="button"
                                            className="px-2 py-1 text-xs font-medium text-white bg-green-500 rounded hover:bg-green-600 mr-1"
                                            onClick={() => setTrainTrackingModal({ isOpen: true, trainNo: m.mawbStatus.train_no, defaultDate: m.mawbStatus?.train_date })}
                                          >
                                            Live
                                          </button>
                                        )}
                                        <button
                                          type="button"
                                          className="p-1 hover:bg-gray-200 rounded-full"
                                          onClick={() => setOpenActionMenu(openActionMenu === m.id ? null : m.id)}
                                        >
                                          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                          </svg>
                                        </button>
                                        {openActionMenu === m.id && (
                                          <div className="absolute right-0 top-full mt-1 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                                            <button
                                              type="button"
                                              className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                                              onClick={() => {
                                                setStatusUpdateModal(m);
                                                setSelectedMotherbagStatus({});
                                                setOpenActionMenu(null);
                                              }}
                                            >
                                              Status Update
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                  {m.id == selectedViewMore && (
                                    <TableRow
                                      key={i + "-view-" + m.id}
                                      className={`border-t ${
                                        m.inscanDone ? "bg-green-500" : m.id == selectedMotherbag ? "bg-blue-200" : "bg-red-400"
                                      }`}
                                    >
                                      <TableCell className="px-3 py-2 text-center" colSpan={14}>
                                        Actual Wt: {m.realWeight} ----- Vendor: {m._vendor?.vendor_name} ----- Airline: {m._airline?.name} ----- Flight:{" "}
                                        {m._flight?.name} ----- Type: {m.type == 2 ? "Console" : "Cargo"}
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </>
                              )
                          )}
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          ))}

          {motherBagList.length === 0 && (
            <div className="text-center text-gray-500 py-10 text-sm">No motherbags found for the selected date range.</div>
          )}
          <div ref={awbSectionRef} className="w-full font-semibold underline text-center mt-5 border-t">Airwaybill Information</div>

          <div className="w-full text-center mt-2">
            <span className="text-sm font-medium text-gray-700">Scan AWB No:</span>
            <input
              type="text"
              ref={awbScanRef}
              className="ml-2 px-3 py-1.5 rounded-lg border-2 border-blue-300 bg-blue-50 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none text-sm font-medium transition-all"
              placeholder="Scan or type AWB number..."
              onKeyDown={disableEnterKey}
              onInput={(e: any) => {
                tryMatchAwb(e.target.value, awbScanRef);
              }}
            />
            {awbDataList.length > 0 && (
              <span className="ml-3 text-sm text-gray-600">
                Scanned: <strong className="text-green-600">{acceptedAwbNos.length}</strong> / {awbDataList.length}
              </span>
            )}
          </div>
          <div className="w-full relative overflow-x-auto mt-2">
            <Table isCompact removeWrapper>
              <TableHeader>
                <TableColumn className="bg-gray-800 text-white py-2 px-3">Check</TableColumn>
                <TableColumn className="bg-gray-800 text-white px-3">No</TableColumn>
                <TableColumn className="bg-gray-800 text-white px-3">Destination</TableColumn>
                <TableColumn className="bg-gray-800 text-white px-3">Weight</TableColumn>
                <TableColumn className="bg-gray-800 text-white px-3">Consignee</TableColumn>
                <TableColumn className="bg-gray-800 text-white px-3">Contact</TableColumn>
                <TableColumn className="bg-gray-800 text-white px-3">Label</TableColumn>
              </TableHeader>
              <TableBody>
                {awbDataList.map((e) => (
                  <TableRow key={"idk" + e.awb_no} className={`${acceptedAwbNos.includes(e.awb_no) ? "bg-green-300" : "bg-white"}`}>
                    <TableCell className="px-3 py-2">{acceptedAwbNos.includes(e.awb_no) ? "YES" : "-"}</TableCell>
                    <TableCell className="px-3 py-2">{e.awb_no}</TableCell>
                    <TableCell className="px-3 py-2">{e.destination}</TableCell>
                    <TableCell className="px-3 py-2">{e.weight}</TableCell>
                    <TableCell className="px-3 py-2">{e.consignee}</TableCell>
                    <TableCell className="px-3 py-2">{e.contact_no}</TableCell>
                    <TableCell className="px-3 py-2">
                      <button
                        type="button"
                        className="text-xs bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-700 transition-colors"
                        onClick={() => { setLabelAwbData(e); setIsLabelOpen(true); }}
                      >
                        Label
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
        {/* </div> */}
        <div className="flex w-full justify-end mt-5 pr-3 mb-4">
          <Button
            type="submit"
            className="rounded-md inline-block px-4 py-2 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
          >
            Accept In-Scan
          </Button>
        </div>
      </form>

      {/* Status Update Modal */}
      {statusUpdateModal && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-start justify-center pt-20 z-50 overflow-auto" onClick={() => setStatusUpdateModal(null)}>
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold"
              onClick={() => setStatusUpdateModal(null)}
            >
              &times;
            </button>

            <h2 className="text-lg font-bold mb-4 border-b pb-2">Update Motherbag Status</h2>

            {/* Motherbag Details for verification */}
            <div className="bg-gray-50 rounded-md p-3 mb-4 text-sm space-y-1">
              <div className="flex justify-between">
                <span className="text-gray-600">Motherbag No:</span>
                <span className="font-semibold">{statusUpdateModal.mother_bag_code}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Origin:</span>
                <span className="font-medium">{statusUpdateModal._subbranch?.branch_name}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Destination:</span>
                <span className="font-medium">{statusUpdateModal._destination?.city_name}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Current Status:</span>
                <span className="font-medium">{statusUpdateModal.status}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Total Nos:</span>
                <span className="font-medium">{statusUpdateModal.totalNos}</span>
              </div>
            </div>

            {/* Status Dropdown */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">New Status</label>
              <Select
                className="bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full"
                options={motherbagStatusList}
                value={selectedMotherbagStatus}
                onChange={(e) => setSelectedMotherbagStatus(e)}
                placeholder="Select status..."
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-2">
              <Button
                type="button"
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300"
                onClick={() => setStatusUpdateModal(null)}
              >
                Cancel
              </Button>
              <Button
                type="button"
                className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
                onClick={() => {
                  if (!selectedMotherbagStatus?.value) {
                    UseToast("Please select a status", "error");
                    return;
                  }
                  addMotherbag_pod({
                    url: "/admin/motherbad_pod/create/",
                    data: {
                      bagId: statusUpdateModal.id,
                      status: selectedMotherbagStatus.value + "",
                      remark: selectedMotherbagStatus.label,
                      dateTime: new Date(),
                    },
                  });
                  setStatusUpdateModal(null);
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Train Tracking Modal */}
      <TrainTrackingModal
        isOpen={trainTrackingModal.isOpen}
        onClose={() => setTrainTrackingModal({ isOpen: false, trainNo: "" })}
        trainNo={trainTrackingModal.trainNo}
        defaultDate={trainTrackingModal.defaultDate}
      />

      {/* Click outside to close action menu */}
      {openActionMenu && (
        <div className="fixed inset-0 z-40" onClick={() => setOpenActionMenu(null)} />
      )}

      {/* AWB Label Modal */}
      {isLabelOpen && (
        <AwbLabel
          isLabelOpen={isLabelOpen}
          setIsLabelOpen={setIsLabelOpen}
          awbData={labelAwbData}
          setAwbData={() => {}}
        />
      )}
    </>
  );
};

export default MotherBagInScan;
